export class BackgroundImage {
    backgroundImageId;
    backgroundImageName;
    backgroundImageUrl;

  constructor(jsonData) {
    Object.assign(this, jsonData);
  }
}
